import React from 'react';
interface NameSupportProps {
    supportName: string | undefined;
}

export const NameSupport = (props: NameSupportProps) => {
    return (
        <div className="title">{props.supportName}</div>
    );
}